import * as React from 'react';
import { RouteProps } from 'react-router';
import { Helmet } from 'react-helmet';

import * as features from 'features';
import { withAsyncFeatures } from 'core';

import { ErrorBoundary } from 'services/ErrorTracking';
import { Alert } from 'services/Alert';
import { WarningModal } from 'services/Warning';
import { getHelmetTale } from 'shared/helpers';

interface IFeatureProps {
  ExportFactAMP: features.ExportFactAMP.Entry;
}

type IProps = RouteProps & IFeatureProps;

class ExportFactAMP extends React.PureComponent<IProps> {
  public render() {
    const { ExportFactAMP } = this.props;

    return (
      <div>
        <Helmet defer={false}>
          <title>Экспорт факт в АМП - {getHelmetTale()} Client Space</title>
        </Helmet>
        <ErrorBoundary>
          <Alert />
          <WarningModal />
          <ExportFactAMP.containers.ExportFactAMP />
        </ErrorBoundary>
      </div>
    );
  }
}

export default withAsyncFeatures({ ExportFactAMP: features.ExportFactAMP.loadEntry })(ExportFactAMP);
